"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pollStatusInfo = exports.addNewPollButton = exports.pollListCardStyles = exports.pollListStyles = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var pollListStyles =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:column;overflow:auto;border-right:1px solid ", _themeConfig.default.color.dark.mars, ";flex-shrink:0;");
exports.pollListStyles = pollListStyles;
var pollListCardStyles =
/*#__PURE__*/
(0, _emotion.css)("cursor:pointer;width:224px;height:48px;border-radius:2px;border-bottom:1px solid ", _themeConfig.default.color.dark.mars, ";padding:7px 24px 9px 10px;&.selected{background-color:", _themeConfig.default.color.dark.venus, ";border-bottom:none;}.poll-question{line-height:1.33;font-family:ChronicaPro-Medium;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.poll-status{line-height:1.6;}");
exports.pollListCardStyles = pollListCardStyles;
var addNewPollButton =
/*#__PURE__*/
(0, _emotion.css)("display:flex;margin-top:12px;.plus-icon{width:12px;height:12px;margin-right:8px;}");
exports.addNewPollButton = addNewPollButton;
var pollStatusInfo =
/*#__PURE__*/
(0, _emotion.css)(".dot{width:3px;height:3px;background-color:", _themeConfig.default.color.dark.iron, ";margin:0 6px;border-radius:50%;}");
exports.pollStatusInfo = pollStatusInfo;